export const productRoutes = [
  { href: "/product/quotation-sales", tKey: "quotation" },
  { href: "/product/project-planning", tKey: "projectPlanning" },
  { href: "/product/engineering", tKey: "engineering" },
  { href: "/product/engineering-services", tKey: "engineeringServices" }
] as const;

export const localeLabels: Record<string, string> = {
  en: "EN",
  sv: "SV",
  de: "DE"
};

export const localeFull: Record<string, string> = {
  en: "English",
  sv: "Svenska",
  de: "Deutsch"
};
